import { useTranslation } from 'react-i18next'

export default function MoneyBackGuarantee() {
  const { t } = useTranslation()

  return (
    <div className="text-custom-black border-primary/20 bg-primary/10 rounded-3xl border p-8 text-center">
      <h2 className="mb-6 text-2xl font-bold sm:text-3xl">
        {t('pages.checkout.plans.moneyBackGuaranteeComponent.title')}
      </h2>
      <p className="text-base leading-relaxed sm:text-lg">
        {t('pages.checkout.plans.moneyBackGuaranteeComponent.description')}
      </p>
    </div>
  )
}
